import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Green_Btn from "../common/common_btn/green_btn/Green_Btn";
import Common_Title_2 from "../common/common_components/common_title_2/Common_Title_2";
import './Attendance_form.css'
import Orange_Btn from "../common/common_btn/orange_btn/Orange_Btn";
import { EventAttendance, SingleEvent } from "../../features/admin/common/Slice";
import { formatEventDate, formatTime, safeBase64Decode } from "../../utils/common";
import Successfull_Modal from "../common/modals/common-modal/successfull_modal/Successfull_Modal";
import { useNavigate } from "react-router-dom";

function Attendance_Form() {
    const dispatch = useDispatch();
    const [successModal, setSuccessModal] = useState(false);
    const navigate = useNavigate();



    const params = new URLSearchParams(window.location.search);
    const encodedId = params.get("eid");

    // const eventId = safeBase64Decode(encodedId);
    const [eventId, setEventId] = useState(null);

    useEffect(() => {
        decode();
    }, [encodedId]);


    const decode = async () => {
        const decoded = await safeBase64Decode(encodedId);
        setEventId(Number(decoded));
        if (decoded)
            await dispatch(SingleEvent({ id: decoded }));
    };

    const event = useSelector((state) => state.common.event);

    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data) => {
        if (!event) {
            alert(`Cannot Mark Attendance!`);
        }
        const sendData = new FormData();

        sendData.append("email", data?.email);
        sendData.append("registration_id", data?.registration_id);
        sendData.append("contact_no", data?.contact_no);
        sendData.append("event_id", event?.event_id);

        const res = await dispatch(EventAttendance(sendData));
        // console.log({ EventAttendance: res });
        if (res.meta?.requestStatus === "fulfilled") {
            reset();
            setSuccessModal(true);
            setTimeout(() => {
                setSuccessModal(false);
                navigate("/home");
            }, 3000);
        } else if (res.meta?.requestStatus === "rejected") {
            alert(`${res?.payload?.errors}`);
        }
    };

    const locationText = [
        event?.Event?.Country?.name,
        event?.Event?.State?.name,
    ]
        .filter(Boolean)
        .join(", ");


    return (
        event?.id && (

            <section className="attendance_form Annadanam_Content_step_2">

                <div className="container">
                    <div className="userForm">

                        <Common_Title_2 subText="Event  Attendance Form" />

                        <div className="step-Form-Container form_div">
                            <div className="form_sec">

                                <div className="details_div">

                                    <p className="title_text">Event Details:</p>

                                    <div className="row">
                                        <div className="col-lg-6">
                                            <p className="subtext">Name : <span className="value_text">{event?.name || "--"}</span></p>
                                            <p className="subtext">Price : <span className="value_text">₹{event?.Event?.price || "--"}</span></p>
                                            <p className="subtext">Location : <span className="value_text">{locationText || "--"}</span></p>
                                        </div>
                                        <div className="col-lg-6 text-end">
                                            <p className="subtext">Dates : <span className="value_text">{formatEventDate(event?.Event?.start_date, event?.Event?.end_date) || "--"}</span></p>
                                            <p className="subtext">Time : <span className="value_text"> {formatTime(event?.Event?.start_time)} to {formatTime(event?.Event?.end_time)}  </span></p>
                                        </div>
                                    </div>



                                </div>

                                <Form>
                                    <div className="row">
                                        {/* Email */}
                                        <div className="col-md-6 mb-3">
                                            <div className="form-group">
                                                <Form.Label>Registration No</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter Registration No."
                                                    {...register("registration_id", {
                                                        required: "Registration No. is required",
                                                        // pattern: {
                                                        //     value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                        //     message: "Enter a valid registration_id",
                                                        // },
                                                    })}
                                                />
                                            </div>
                                            {errors?.registration_id && (
                                                <Form.Text className="text-danger">
                                                    {errors.registration_id.message}
                                                </Form.Text>
                                            )}
                                        </div>

                                        {/* Contact */}
                                        {/* <div className="col-md-6 mb-3">
                                            <div className="form-group">
                                                <Form.Label>Phone Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Contact Number"
                                                    maxLength={10}
                                                    {...register("contact_no", {
                                                        required: "Contact Number is required",
                                                        pattern: {
                                                            value: /^[0-9]+$/,
                                                            message: "Only digits are allowed",
                                                        },
                                                        minLength: {
                                                            value: 10,
                                                            message: "Contact Number must be exactly 10 digits",
                                                        },
                                                        maxLength: {
                                                            value: 10,
                                                            message: "Contact Number must be exactly 10 digits",
                                                        },
                                                    })}
                                                />
                                            </div>
                                            {errors?.contact_no && (
                                                <Form.Text className="text-danger">
                                                    {errors.contact_no.message}
                                                </Form.Text>
                                            )}
                                        </div> */}

                                        {/* Submit */}
                                        <div className="apply_div">
                                            <Orange_Btn onClick={handleSubmit(onSubmit)} btnText="Mark attendance" type="submit" />
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <Successfull_Modal
                    show={successModal}
                    onHide={() => setSuccessModal(false)}
                    headtext={"Event Attendance"}
                    successfultext={" Attendance Registered Successfully!"}
                    subtext={""}
                    subtext2={"Have a nice time ahead"}
                />
            </section>)
    );
}

export default Attendance_Form;
